import { FC } from 'react';
import { observer } from '~/modules';
import CreditSimulationSuccess from './CreditSimulationSuccess';

const CreditSimulationSuccessContainer: FC = () => {
  return <CreditSimulationSuccess />;
};
export default observer(CreditSimulationSuccessContainer);
